interface AddressObject {
  street: string
  apt: string
  city: string
  state: string
  zipCode: string
}

const getAddress = (props: AddressObject): string => {
  if (!props || !Object.keys(props).length) {
    return ''
  }

  const stateZip = [ props.state, props.zipCode ]
    .filter((part) => part)
    .join(' ')

  const parts = [
    props.street,
    props.apt,
    props.city,
    stateZip,
  ]
    .filter((part) => part)

  return parts.join(', ')
}


export default getAddress
